<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <h3 class="font-bold pb-2">{{ project.name }}</h3>
    <p class="font-bold text-sm" v-if="project.primary_customer">
      {{ project.primary_customer.name }}
    </p>
    <template v-if="project.place">
      <p class="text-sm">
        {{ project.place.address_1 }}
        <template v-if="project.place.address_2">
          - {{ project.place.address_2 }}
        </template>
      </p>
      <p class="text-sm">
        {{ project.place.city }}, {{ project.place.state }}
        {{ project.place.zip }}
        <a
          class="ml-1 text-red hover-bold"
          :href="generateGoogleMapsUrl(project.place)"
        >
          <i class="fal fa-map-marker-alt"></i>
        </a>
      </p>
    </template>
    <p class="text-sm" v-if="project.email">
      <a class="text-red hover-bold" :href="`mailto:${project.email}`">
        {{ project.email }}
      </a>
    </p>
    <p
      class="text-sm"
      v-if="project.primary_phone && project.primary_phone.number"
    >
      {{ project.primary_phone.number }}
    </p>
  </list-view-cell>
</template>

<script>
import { ContextMenuItem } from "../../../helper-classes/ContextMenuItem";
import { Project } from "../../../models/Project";
import ProjectForm from "../../../forms/ProjectForm";
import ListViewCell from "./ListViewCell";
import GenericDeleteModal from "../../../components/modals/GenericDeleteModal";

export default {
  name: "ProjectCell",
  components: { ListViewCell },
  props: {
    project: { type: Project, required: true }
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("view", () => {
          this.$router.push({
            name: "projects-show",
            params: { id: this.project.id, project: this.project }
          });
        }),
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ProjectForm,
            createEditComponentData: this.project,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: GenericDeleteModal,
            bodyComponentData: {
              entityName: "project",
              deleteFunction: () => {
                this.deleteProject(this.project);
              }
            },
            isShown: true
          });
        })
      ]
    };
  },
  methods: {
    deleteProject(project) {
      this.$store.dispatch("deleteProject", project).then(res => {
        this.$store.dispatch("handleApiResponse", {
          responseStatus: res,
          successText: "Project deleted successfully.",
          errorText: "An error occurred while attempting to delete Project.",
          afterSuccessFunction: () => {
            if (this.$store.state.Search.areSearchResultsShown) {
              this.$store.dispatch(
                "searchProjects",
                this.$store.state.Search.searchTerm
              );
            } else {
              this.$store.dispatch("getProjects");
            }
            this.$store.commit("resetConfirmationModalParams");
          }
        });
      });
    }
  }
};
</script>

<style scoped></style>
